module.exports = __webpack_public_path__ + "img/mail.7f0dcd09.svg";